





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import CircleInfo from '@/components/icons/CircleInfo.vue';
import RulesSpecialCoin from '@/components/organisms/Offers/RulesSpecialCoin.vue';
import BirthdayCoinSettings from '@/components/organisms/Offers/DataPresentation/BirthdayCoinSettings.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';

import flagKeys from '@/constants/flagKeys';
import { SpecialOfferTypeEnum } from '@/models/offer';
import CollapseRowV2 from '@/componentsV2/molecules/CollapseRowV2/CollapseRowV2.vue';
import segmentIo from '@/utils/segment.io';

import { IDataOffer } from '../FormOffer.vue';

@Component({
  components: {
    TextField,
    FormHeader,
    CircleInfo,
    RulesSpecialCoin,
    BirthdayCoinSettings,
    CollapseRowV2,
    ArrowDownIcon
  }
})
export default class AdvancedOptions extends Vue {
  @Prop() errors!: string[];
  @Prop() offerData?: IDataOffer;

  data = {
    rules: this.offerData && this.offerData.rules ? this.offerData.rules : {},
    description:
      this.offerData && this.offerData.description
        ? this.offerData.description
        : ''
  };

  collapsed = false;

  get tPrefix() {
    return 'offers.form';
  }

  get isBirthday() {
    return this.$route.query.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get isHappyHour() {
    return this.$route.query.type === SpecialOfferTypeEnum.HAPPY_HOUR;
  }

  get characterLimitationIsActivated() {
    return !this.flags.includes(flagKeys.disableCharacterLimitationOnOffer);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  clickCollapse() {
    this.collapsed = !this.collapsed;
  }

  changeRules(rules: any, firstLoad?: boolean) {
    if (!firstLoad) {
      segmentIo.track('Changed Offer Rules', { Rules: rules });
    }
    this.data.rules = rules;
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }
}
